import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/breathing.css';
import ss from '../assets/images/ss.png';

const MindfulBreathing = () => (
  <div class="breathing">
    <section class="main">
        <div class="description">
            <h1>Mindful Breathing App</h1>
            <div class="logos">
                <div class="appstore">
                    <a href="https://apps.apple.com/app/mindfull-breathing/id1607602377" title="Mindfull Breathing app" target="_blank" rel="noopener"></a>
                </div>
                <div class="playstore">
                    <a href="https://play.google.com/store/apps/details?id=com.mindfulbreathing" title="Mindful Breathing app" target="_blank" rel="noopener"></a>
                </div>
            </div>
            <div class="desc">
            <h3>Programmable guided breathing app</h3>
                Mindful Breathing is a simple, easy to use, powerful and highly customizable app to guide you with breathing exercises. This app is designed keeping the user in mind to provide a basic breathing tool with fully customizable options according to user preference. 
            </div>
            <div class="desc">
                <h3>Benefits:</h3>

                <p>1) No Cost or In-App purchases.</p>
                <p>2) No Advertisements or Distractions.</p>
                <p>3) No User Registration or Login.</p>
                <p>4) No Tracking User Information.</p>
                <p>5) No Internet required (Offline app).</p>
                
            </div>
            <div class="desc">
            <h3>Features:</h3>
            <p>1) Simple and Beautiful breathing visualizer with customizable options on the breath screen.</p>
            <p>2) Custom cycles to set preferred durations for Inhale, Hold and Exhale. Along with repeat times.</p>
            <p>3) Predefined breathing cycles like Triangle, Box, Equal, Coherent, Relaxing and Full breath retention with duration hint.</p>
            <p>4) Fully customizable Audio options like Sound cue, Voice over and Background soothing music.</p>
            <p>5) Vibration cue to hint the difference between Inhale, Hold and Exhale.</p>
            <p>6) Multiple theme options including light, dark and other gradient colors.</p>
            <p>7) Hidden Advanced options to explore and customize multiple features.</p>
            <p>8) Options to customize Vibrate, Audio, Music settings in case of Hold cycle.</p>
            <p>9) Option to have an initial delay before the breathing cycle starts.</p>
            <p>10) Option to show sound and message after the breathing exercise is completed.</p>
            <p>11) Fully customization options for breathe screen, what to show and what not.</p>
            <p>12) Detailed help tutorial with all the options explained.</p>
            <p>13) Settings saved locally in the app</p>
            <p>14) Multiple sound cue options</p>
            <p>15) Multiple soothing background music options</p>
            </div>
            <div class="desc">
                <h3>Breathing programs/cycles:</h3>
                <p>1) Triangle breathing</p>
                <p>2) Box breathing</p>
                <p>3) Equal breathing</p>
                <p>4) Coherent breathing</p>
                <p>5) Relaxing breathing</p>
                <p>6) Full Breath Retention breathing</p>
            </div>
            <div class="privacy">
                <Link to='/mindfulbreathing/privacy'>Privacy link</Link>
            </div>
        </div>
        <div class="screens">
            <img alt="" src={ss}/>
        </div>
    </section>
  </div>
)

export default MindfulBreathing
